import { z } from "zod";
export const GovernedProjectActivationRequestV1Schema = z
    .object({
    schemaVersion: z.literal("governed-project-activation.v1.0"),
    claimId: z.string().min(1),
    publicReportRef: z.string().min(1),
    targetProjectId: z.string().min(1),
    existingActiveProjectId: z.string().min(1).optional(),
})
    .strict();
export const GovernedProjectActivationResultV1Schema = z
    .object({
    schemaVersion: z.literal("governed-project-activation-result.v1.0"),
    claimId: z.string().min(1),
    projectId: z.string().min(1),
    draftOnly: z.literal(true),
    duplicateTruthBlocked: z.boolean(),
    activationDeferredReason: z.string().min(1).optional(),
})
    .strict();
/**
 * GR-007 — claim → governed project without parallel active truth.
 * Never activates BusinessGraph truth; draft boundary only.
 */
export function planClaimToGovernedProject(input) {
    const parsed = GovernedProjectActivationRequestV1Schema.parse(input);
    const duplicateTruthBlocked = parsed.existingActiveProjectId !== undefined &&
        parsed.existingActiveProjectId !== parsed.targetProjectId;
    if (duplicateTruthBlocked) {
        return GovernedProjectActivationResultV1Schema.parse({
            schemaVersion: "governed-project-activation-result.v1.0",
            claimId: parsed.claimId,
            projectId: parsed.targetProjectId,
            draftOnly: true,
            duplicateTruthBlocked: true,
            activationDeferredReason: "parallel_active_truth_blocked",
        });
    }
    return GovernedProjectActivationResultV1Schema.parse({
        schemaVersion: "governed-project-activation-result.v1.0",
        claimId: parsed.claimId,
        projectId: parsed.targetProjectId,
        draftOnly: true,
        duplicateTruthBlocked: false,
        activationDeferredReason: "governed_delivery_requires_human_confirmation",
    });
}
//# sourceMappingURL=claim-to-governed-project.js.map